import { keyBy } from 'lodash';

import permissions from 'api/Apollo/permissions';
import { METHOD, PATH } from 'api/control/control-api';
import { useControlProxy, normalizeResponse } from 'api/control/useControlProxy';
import { useQueryIntegrationNames } from 'api';

export default function useGetEventValues(options = {}) {
  const { integrations, loading: integrationsLoading, error: integrationsError } = useQueryIntegrationNames();
  const [call, response] = useControlProxy({ permission: permissions.readEvents, ...options });

  const getEventValues = ({ clusterId }) => {
    return call({
      path: PATH.EventValues,
      method: METHOD.GET,
      body: {},
      clusterId,
    });
  };

  const normalizedResponse = normalizeResponse(response);

  const transformedResponse = {
    eventValues: transformResponse(normalizedResponse, integrations),
    loading: normalizedResponse.loading || integrationsLoading,
    error: normalizedResponse.error || integrationsError,
  };

  return [getEventValues, transformedResponse];
}

function transformResponse(response, integrations) {
  if (!response?.data || !integrations) {
    return [];
  }

  const { integrationIds } = response.data;

  const integrationsById = keyBy(integrations, 'id');

  const transformedIntegrations = integrationIds.reduce((acc, integrationId) => {
    const managedIntegration = integrationsById[integrationId];

    if (managedIntegration) {
      const integration = {
        id: managedIntegration.id,
        name: managedIntegration.name,
        starterkitId: managedIntegration.starterkitId,
      };

      return [...acc, integration];
    }

    return acc;
  }, []);

  return {
    ...response.data,
    integrations: transformedIntegrations,
  };
}
